<template>
<!-- 积分规则 -->
<div class="viewContainer">
  <div class="main_container">
    <section class="model_section">
      <p class="model_top_title">积分规则</p>
    </section>
    <!-- table 列表 -->
    <div class="table_container">
      <el-table :data="goodList" stripe border :span-method="arraySpanMethod" :row-style="tableRowClassName">
        <el-table-column label="序号" align="center" width="68px">
          <template scope="scope">{{scope.$index + 1}}</template>
        </el-table-column>
        <el-table-column prop="name" label="规则名称" align="center">
          <template scope="scope">{{ scope.row.name }}</template>
        </el-table-column>
        <el-table-column prop="integral" label="积分" align="center">
          <template scope="scope">{{ scope.row.integral }}</template>
        </el-table-column>
        <el-table-column prop="ruleDescribe" align="center" label="规则描述">
          <template scope="scope">{{ scope.row.ruleDescribe }}</template>
        </el-table-column>
        <el-table-column prop="stateName" label="状态" align="center">
          <template scope="scope">{{ scope.row.stateName }}</template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" align="center" width="360px">
          <template scope="scope">
            <!-- 设置 -->
            <span class="handle" @click="openPointSetting(scope)" v-if="scope.row.setting == 0">
              <i class="el-icon-circle-check"></i>设置
            </span>
            <template v-else>
              <!-- 编辑 v-if="scope.row.state == 4" -->
              <span class="handle" @click="emitinfo(scope.row, 1)">
                <i class="el-icon-edit-outline"></i> 编辑
              </span>
              <!-- 开启 -->
              <span class="handle" @click="cardStatus(scope.row)">
                <i :class="scope.row.state == 1 ? 'el-icon-circle-close' : 'el-icon-circle-check'"/>
                {{ scope.row.state == 1 ? "关闭" : "开启" }}
              </span>
            </template>
          </template>
        </el-table-column>
      </el-table>
      <el-pagination layout="prev, pager, next" @current-change="handleCurrentChange"
      :current-page="pageIndex" :page-size="10" :total="total" style="margin: 10px 0; float: right"/>
    </div>
  </div>

  <!-- 新增/编辑推广-弹框 -->
  <el-dialog title="积分到期设置" :visible.sync="pointSettings" width="35%" @close="cancelFun()" center>
    <!-- disabled -->
    <el-radio-group v-model="pointSettingsRadio" size="mini" @change="pointChange">
      <el-radio label="1">永久有效</el-radio>
      <el-radio label="0" style="margin-top: 15px">每年&nbsp;&nbsp;
        <el-date-picker type="date" v-model="pointDate" :disabled="pointSettingsRadio == 1 ? true : false"
          format="MM-dd" value-format='MM-dd' popper-class="dataChoose" placeholder="选择日期" @change='changeDate'>
        </el-date-picker>
        &nbsp;&nbsp;清除积分池所有积分
      </el-radio>
    </el-radio-group>

    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left: 0; text-align: center; margin-top: 25px">
      <el-button @click="cancelFun()">取消</el-button>
      <el-button type="danger" @click="editSubmit()">保存</el-button>
    </div>
  </el-dialog>
  <!-- 新用户注册 -->
  <el-dialog :title="integralName" :visible.sync="integralNameConfig" width="40%" @close="cancelIntegralConfigFun()" center>
    <el-form :model="addGoodsForm" ref="addGoodsForm" label-width="95px" class="demo-ruleForm">
      <el-row :gutter="20">
        <el-col :span="19">
          <!-- 新用户首单 -->
          <template v-if="integralId == 3">
            <el-form-item label="积分:" prop="integral">
              <el-row :gutter="0">
                <el-col :span="19">
                  <el-input v-model="addGoodsForm.integral" placeholder="请输入积分" maxlength="7"
                    oninput="value=value.replace(/[^\d]/g,'')"
                    onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
                </el-col>
                <el-col :span="5">
                  <span>&nbsp;&nbsp;+&nbsp;&nbsp;下单积分 </span>
                </el-col>
              </el-row>
            </el-form-item>
          </template>
          <!-- 下单(存在每消费金额) -->
          <template v-else-if="integralId == 4 || integralId == 16">
            <el-form-item label="积分:" prop="integral">
              <el-row>
                <el-col :span="24">
                  每消费&nbsp;&nbsp;<el-input v-model="addGoodsForm.getRule" placeholder="请输入金额" maxlength="7"
                    style="display: inline-block; width: 30%" oninput="value=value.replace(/[^\d]/g,'')"
                    onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>&nbsp;元时，获得&nbsp;
                    <el-input v-model="addGoodsForm.integral" placeholder="请输入积分" maxlength="7"
                    style="display: inline-block; width: 30%" oninput="value=value.replace(/[^\d]/g,'')"
                    onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>&nbsp;&nbsp;积分
                </el-col>
                <!-- <el-col :span="12">
                  
                </el-col> -->
              </el-row>
            </el-form-item>
          </template>
          <template v-else>
            <el-form-item label="积分:" prop="integral">
              <el-input v-model="addGoodsForm.integral" placeholder="请输入积分" maxlength="7"
                width="100%" oninput="value=value.replace(/[^\d]/g,'')"
                onkeyup="value=value.replace(/^\D*(\d*(?:\.\d{0,2})?).*$/g, '$1')"/>
            </el-form-item>
          </template>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="19">
          <el-form-item label="规则描述:" prop="ruleDescribe">
            <el-input type="textarea" v-model="addGoodsForm.ruleDescribe"
              placeholder="请输入规则描述" maxlength="50" style="color: #606266" :rows="3"/>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="20">
        <el-col :span="19">
          <el-form-item label="状态:" prop="state">
            <el-select v-model="addGoodsForm.state" placeholder="请选择状态" filterable style="width: 100%">
              <el-option v-for="(item, index) in groupTypeList" :key="index" :value="item.Value" :label="item.Name"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <!-- 弹框按钮 确定/取消 -->
    <div style="padding-left: 0; text-align: center; margin-top: 25px">
      <el-button @click="cancelIntegralConfigFun()">取消</el-button>
      <el-button type="danger" @click="editIntegralConfigSubmit()">保存</el-button>
    </div>
  </el-dialog>
</div>
</template>
<script>
import alertTrends from '../../common/alertTrends.js';
import { GetIntergralRuleList, OpenOrClozeIntergralRule, SetIntergralClearRule, UpdateIntergralRule, } from "../../api/shopWindow";
export default {
  name: "IntegralModule",
  mixins: [alertTrends],
  data() {
    return {
      pageIndex: 1,
      total: 0,
      //状态基础数据
      groupTypeList: [
        {
          Value: 1,
          Name: "开启",
        },
        {
          Value: 0,
          Name: "关闭",
        },
      ],

      addGoodsForm: {
        integral: "", //积分
        ruleDescribe: "", //规则描述
        state: "", //状态
        getRule: "", //状态
      },
      goodList: [],
      pointSettings: false, //积分设置时间弹框
      pointSettingsRadio: "1", //积分设置选项
      pointDate: "", //积分日期
      integralNameConfig: false, //积分设置配置项弹框
      integralName: "新用户注册", //积分配置名称
      integralId: "", //积分配置选中弹框id
    };
  },
  methods: {
    // 事件选择更换
    changeDate(e){
      console.log(e);
      // this.pointDate=e;
    },
    //   合并单元格 （第一行 积分设置）
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        if (columnIndex === 1) {
          return [1, 3];
        } else if (columnIndex > 1 && columnIndex <= 3) {
          return [0, 0];
        }
      }
    },
    // 每行的表格样式  （第一行  字体加粗）
    tableRowClassName({ row, rowIndex }) {
      if (rowIndex === 0) {
        var stylejson = {
          "font-weight": 700,
        };
        return stylejson;
      }
    },
    // 表格后的操作
    openState(e) {
      console.log(e);
    },
    // 开启、关闭
    cardStatus(scope) {
      this.cardId = scope.id;
      this.$swal({
        type: "warning",
        text: scope.state == 1 ? "是否执行关闭操作" : "是否执行开启操作",
        showCancelButton: true,
        cancelButtonText: "取消",
        confirmButtonText: "确定",
      }).then((res) => {
        if (res.value) {
          this.makesure(scope.state == 0 ? 1 : 0);
        }
      });
    },
    // 确定执行操作--调取开启关闭接口
    makesure(type) {
      var obj = {
        id: this.cardId,
        state: type,
      };
      OpenOrClozeIntergralRule(obj).then((data) => {
        if (data.ResultCode == 1) {
          this.init();
          this.showAlert('操作成功', 'success');
        }
      });
    },
    // 编辑积分
    emitinfo(scope) {
      this.integralNameConfig = true;
      this.integralName = scope.name;
      this.integralId = scope.id;
      var addGoodsForm=JSON.stringify(scope)
      this.addGoodsForm=JSON.parse(addGoodsForm);
      this.addGoodsForm.integral=this.addGoodsForm.getIntegral;
    },
    // 取消设置积分
    cancelFun() {
      this.pointSettings = false;
    },
    // 积分设置--确定按钮
    editSubmit() {
      if (!this.pointSettingsRadio) {
        this.showAlert('请选择时间类型');
        return false;
      }
      if (this.pointSettingsRadio == 0 && !this.pointDate) {
        this.showAlert('请选择积分到期时间');
        return false;
      }

      let params = {
        id: this.integralId,
        isPermenate: this.pointSettingsRadio,
        clearTime: this.pointDate,
      };
      SetIntergralClearRule(params).then((data) => {
        if (data.ResultCode == 1) {
          this.pointSettings = false;
          this.init();
          this.showAlert('操作成功', 'success');
        }
      });
    },
    // 积分到期设置
    openPointSetting() {
      this.pointSettings = true;
      //   编辑回显时需要使用异步方法请求  将接口返回的数据回填
    },
    // 永久有效   or   日期
    pointChange(e) {
      if (this.pointSettingsRadio == "1") {
        this.pointDate = "";
      }
    },
    // 清空表单
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
    // 积分配置关闭按钮
    cancelIntegralConfigFun() {
      this.resetForm("addGoodsForm");
      this.integralNameConfig = false;
      this.addGoodsForm.getRule = "";
    },
    // 积分配置确定按钮
    editIntegralConfigSubmit() {
      // 下单支付时验证每消费金额必填(存在每消费金额)
      if (
        !this.addGoodsForm.getRule &&
        (this.integralId == 4 || this.integralId == 16)
      ) {
        this.showAlert('请输入金额');
        return false;
      }
      if (!this.addGoodsForm.integral) {
        this.showAlert('请输入积分');
        return false;
      }
      if (this.addGoodsForm.state!==0&&this.addGoodsForm.state!==1) {
        this.showAlert('请选择状态');
        return false;
      }
      let params = {
        id: this.integralId,
        ...this.addGoodsForm
      };
      UpdateIntergralRule(params).then((data) => {
        if (data.ResultCode == 1) {
          this.pointSettings = false;
          this.init();
          this.showAlert('操作成功', 'success');
          // 成功之后清空表单并关闭弹框 错误提示错误信息
          this.cancelIntegralConfigFun();
        }
      });
    },
    // 分页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.init();
    },
    // 初始化
    init() {
      GetIntergralRuleList().then((res) => {
        if (res.ResultCode == 1) {
          this.goodList = [
            {
              name: "积分到期设置",
              integral:res.ResultObj.clearTime,
              setting: 0,
            },
            ...res.ResultObj.IntegralRuleModels,
          ];
          this.integralId = res.ResultObj.id;
          this.pointSettingsRadio = res.ResultObj.isPermenate.toString();
          this.pointDate=res.ResultObj.isPermenate!=1?res.ResultObj.clearDate.substring(5,res.ResultObj.clearDate.length):null;
        } else {
          this.goodList = [];
        }
      });
    },
  },
  created() {
    this.init();
  },
};
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// IntegralRule.vue?53fa55c2